var render = function render(){var _vm=this,_c=_vm._self._c;return (!!_vm.vip && _vm.vip > 0)?_c('span',{staticClass:"red"},[_vm._v("VIP "+_vm._s(_vm.vip))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }